import React, { useEffect, useState } from 'react';
import { FormikProps } from 'formik';
import { Heading, Field, Flex, Box, Label, Container } from 'theme-ui';
import { GrayFormikField } from '@/components/GrayFormikField';
import { IncentiveActionType, SelectOption } from '@/types/types';
import { useLazyGetLicenseTypesQuery } from '@/store/apiService';
import Button from '@/components/Button';
import Error from '@/components/Error';
import { incentiveActionTypesOptions } from './common';
import { ActionTypes } from 'xstate';

export const initialValues = {
    ActionType: 1,
    Page: '',
    Section: '',
    Element: '',
    LicenseTypeId: '',
};

interface FormProps extends FormikProps<any> {
    // licenseTypesOptions: SelectOption[];
    additionalErrors?: React.ReactNode;
}

export const ActionForm: React.FC<FormProps> = ({
    handleChange,
    values,
    additionalErrors,
    ...props
}) => {
    const [getLicenseTypes, licenseTypes] = useLazyGetLicenseTypesQuery({});
    const [actionType, setActionType] = useState(values.ActionType);

    const licenseTypesOptions = licenseTypes.data
        ? licenseTypes.data.Results.map((licenceType) => ({
            // @ts-ignore
            value: licenceType.Id,
            label: licenceType.Name,
        }))
        : [];

    useEffect(() => {
        getLicenseTypes({ ExtraLicenseOption: Number(actionType) === IncentiveActionType.AddOn ? true : false });
    }, [actionType]);

    return (
        <Flex backgroundColor="Background" sx={{ flexDirection: 'column', borderRadius: 'sm' }}>
            <Flex
                p="2"
                sx={{
                    gap: 2,
                    '@media only screen and (max-width:60em)': {
                        flexDirection: 'column',
                    },
                    borderRadius: 'sm',
                }}
            >
                <Box
                    sx={{
                        flexBasis: '50%',
                        borderRadius: 'sm',
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        borderColor: 'gray.2',
                        alignSelf: 'flex-start',
                    }}
                    p="3"
                >
                    <Heading as="h3">Action</Heading>

                    <Label>Action Type</Label>
                    <GrayFormikField
                        type="select"
                        name="ActionType"
                        options={incentiveActionTypesOptions}
                        onChange={(evt) => {
                            handleChange(evt);
                            console.log(evt.target)
                            setActionType(Number(evt.target.value));
                        }}
                    />
                    <GrayFormikField name="Description" type="textarea" label="Description" />
                    <GrayFormikField name="Page" type="string" label="Page" />
                    <GrayFormikField name="Section" type="string" label="Section" />
                    <GrayFormikField name="Element" type="string" label="Element" />

                    {Number(actionType) === IncentiveActionType.Upgrade || Number(actionType) === IncentiveActionType.AddOn ? (
                        <>
                            <Label>Suggested license</Label>
                            <GrayFormikField
                                type="select"
                                name="LicenseTypeId"
                                options={licenseTypesOptions}
                            />
                        </>
                    ) : null}
                    {additionalErrors ? (
                        <Box>
                            <Container variant="error-message">
                                <Error error={additionalErrors as any} />
                            </Container>
                        </Box>
                    ) : null}
                    <Flex
                        p="2"
                        sx={{
                            width: '100%',
                            gap: 2,
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Button
                            isLoading={props.isSubmitting}
                            disabled={props.isSubmitting}
                            type="submit"
                            onClick={props.submitForm}
                        >
                            Save
                        </Button>
                        {/* TODO: add errors */}
                    </Flex>
                </Box>
            </Flex>
        </Flex>
    );
};
